module.exports = __webpack_public_path__ + "img/wallis-and-futuna.121ae504.svg";